var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pricing-for-special-groups-wrapper position-relative" },
    [
      _c("div", { staticClass: "pricing-for-special-groups" }, [
        _c(
          "h1",
          { staticClass: "title text-center font-outfit-semi-bold" },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("pages.pricing.pricingForSpecialGroups.pricingFor")
                ) +
                " "
            ),
            _c("underlined-text", { staticClass: "underlined-text" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "pages.pricing.pricingForSpecialGroups.specialGroups"
                    )
                  ) +
                  " "
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "cards-wrapper m-auto" },
          [
            _c("pricing-for-special-groups-card", {
              staticClass: "special-groups-card",
              attrs: {
                image: require("@/assets/img/pricing/pricing-for-special-groups/boy-with-phone.webp"),
                subtitle: _vm.$t(
                  "pages.pricing.pricingForSpecialGroups.enterprisePlan.subtitle"
                ),
                description: _vm.$t(
                  "pages.pricing.pricingForSpecialGroups.enterprisePlan.description"
                ),
              },
              on: { click: _vm.onEnterpriseContact },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "cards-wrapper m-auto" },
          [
            _c("pricing-for-special-groups-card", {
              attrs: {
                image: require("@/assets/img/pricing/pricing-for-special-groups/woman.png"),
                subtitle: _vm.$t(
                  "pages.pricing.pricingForSpecialGroups.schoolsSection.subtitle"
                ),
                description: _vm.$t(
                  "pages.pricing.pricingForSpecialGroups.schoolsSection.description"
                ),
                reverse: "",
              },
              on: { click: _vm.onSchoolsContact },
            }),
          ],
          1
        ),
      ]),
      _c("dialog-enterprise", {
        attrs: {
          "enterprise-visible": _vm.dialogEnterpriseVisible,
          type: _vm.dialogEnterpriseType,
        },
        on: { "close-enterprise": _vm.onDialogEnterpriseClose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }